
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`🚀 JXML: Render components from Yaml file.`}</h2>
    <h3>{`Install:`}</h3>
    <pre {...{
      "className": "language-bash"
    }}><code parentName="pre" {...{
        "className": "language-bash"
      }}><span parentName="code" {...{
          "className": "token function"
        }}>{`npm`}</span>{` i jxml-react
`}</code></pre>
    <h3>{`Add webpack config:`}</h3>
    <pre {...{
      "className": "language-jsx"
    }}><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`module`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`.`}</span><span parentName="code" {...{
          "className": "token property-access"
        }}>{`exports`}</span>{` `}<span parentName="code" {...{
          "className": "token operator"
        }}>{`=`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
  module`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
    `}<span parentName="code" {...{
          "className": "token comment"
        }}>{`// ...`}</span>{`

    rules`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`[`}</span>{`
      `}<span parentName="code" {...{
          "className": "token comment"
        }}>{`// ...`}</span>{`

      `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`{`}</span>{`
        test`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token regex"
        }}><span parentName="span" {...{
            "className": "token regex-delimiter"
          }}>{`/`}</span><span parentName="span" {...{
            "className": "token regex-source language-regex"
          }}>{`\\.jxml?$`}</span><span parentName="span" {...{
            "className": "token regex-delimiter"
          }}>{`/`}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{`
        use`}<span parentName="code" {...{
          "className": "token operator"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`[`}</span><span parentName="code" {...{
          "className": "token string"
        }}>{`'babel-loader'`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{` `}<span parentName="code" {...{
          "className": "token string"
        }}>{`'jxml-react/loader'`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`]`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{`
      `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{`
    `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`]`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{`
  `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`,`}</span>{`
`}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`}`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`;`}</span>{`
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;